<template>
  <Content>
    <Card>
      <template slot="title">{{$t('manage.licenseInfo')}}</template>

      <Form :label-width="120">
        <FormItem :label="$t('manage.email')" class="group">
          <span>{{licenseInfo.license.email}}</span>
        </FormItem>
        <FormItem :label="$t('license.number')">
          <span>{{licenseInfo.license.number}}</span>
        </FormItem>
        <FormItem :label="$t('manage.licenseType')" class="group">
          <span v-if="stripeInfo.available">{{$t('manage.interval.' + stripeInfo.data.interval)}}</span>
          <span v-else-if="licenseInfo.license.metadata && licenseInfo.license.metadata.interval">
            {{$t('manage.interval.' + licenseInfo.license.metadata.interval)}}
          </span>
          <span v-else>{{$t('loading')}}</span>
        </FormItem>
        <FormItem :label="$t('manage.expiration')" class="group" v-if="!stripeInfo.available">
          <span>{{licenseInfo.license.exp|moment('subtract', '1 days', $t('dateFormat'))}}</span>
        </FormItem>
        <FormItem :label="$t('manage.autoRenewal')">
          <span v-if="stripeInfo.data.autoRenewal">{{$t('yes')}}</span>
          <span v-else>{{$t('no')}}</span>
        </FormItem>
        <FormItem :label="$t('manage.appCollections')">
          <div style="position: relative; padding-top: 4px;">
            <ul>
              <li v-for="appCollection in licenseInfo.appCollections" :key="appCollection.id">{{appCollection.name}}</li>
            </ul>
          </div>
        </FormItem>
      </Form>
      <ElementLoader :show="licenseInfo.loading" />
    </Card>

    <Card v-if="stripeInfo.loading || stripeInfo.available">
      <template slot="title">{{$t('manage.subscriptions')}}</template>
      <form method="POST" :action="billingPortalUrl">
        <button class="billing-portal-btn" type="submit" v-show="stripeInfo.available">
          {{$t('manage.manageThroughPortal')}}
        </button>
      </form>

      <ElementLoader :show="stripeInfo.loading" />
    </Card>

    <Card v-if="feideInfo.loading || feideInfo.available">
      <template slot="title">{{$t('manage.feide.groupsAccess')}}</template>
      <Tree :data="feideInfo.data"
            show-checkbox
            :empty-text="$t('manage.feide.noGroups')"
            @on-check-change="feideCheck"></Tree>
      <ElementLoader :show="feideInfo.loading" />
    </Card>

    <!-- <Card v-show="stripeInfo.available">
      <template slot="title">{{$t('manage.paymentInfo')}}</template>

      <SavedCard v-for="card in stripeInfo.data.payment_methods" :key="card.id" :card="Object.assign(card.card, {id: card.id})"
                  @remove="stripeInfo.data.payment_methods = stripeInfo.data.payment_methods.filter(p => p !== card)" />

      <div class="add-card" @click="addCard.show = true">
        <span>+</span>
      </div>
      <Modal v-model="addCard.show"
          :title="$t('manage.addCard')"
          :loading="addCard.loading"
          :ok-text="$t('accept')"
          :cancel-text="$t('cancel')"
          @on-ok="stripeValidate">
          <div ref="card"></div>
          <div>{{addCard.error}}</div>
      </Modal>

      <ElementLoader :show="stripeInfo.loading" />
    </Card> -->

    <!-- <Card v-if="stripeInfo.available">
      <template slot="title">{{$t('manage.invoices')}}</template>

      <Invoice v-for="invoice in stripeInfo.data.invoices" :key="invoice.id" :invoice="invoice" />

      <ElementLoader :show="stripeInfo.loading" />
    </Card> -->
  </Content>
</template>

<script>
import axios from 'axios';
import {mapState} from 'vuex';
// import SavedCard from '../../components/SavedCard.vue';
// import Subscription from '../../components/Subscription.vue';
// import Invoice from '../../components/Invoice.vue';
import ElementLoader from '../../components/ElementLoader.vue';

const stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
// const elements = stripe.elements();
// let cardElement = undefined;

export default {
  created() {
    if (this.license) {
      this.licenseInfo.loading = false;
      this.licenseInfo.license = this.license;
      this.licenseInfo.appCollections = this.license.appCollections;
    } else {
      axios.get(process.env.VUE_APP_ROOT_API + '/api/license').then(response => {
        this.licenseInfo.loading = false;
        this.licenseInfo.license = response.data;
        this.licenseInfo.appCollections = response.data.appCollections;
        this.$store.dispatch('license/set', response.data);
      }).catch(error => {
        if (error.response && error.response.status === 401) {
          this.$store.dispatch('license/logOut');
          this.$router.replace('/login');
        } else {
          this.$Message.error({content: error.message, duration: 5});
        }
      });
    }
  },
  mounted() {
    axios.get(process.env.VUE_APP_ROOT_API + '/api/stripe').then(response => {
      this.stripeInfo.loading = false;
      this.stripeInfo.data = response.data;
      this.stripeInfo.available = true;
    }).catch(error => {
      this.stripeInfo.loading = false;
      if (error.response && error.response.status === 401) {
        this.$store.dispatch('license/logOut');
        this.$router.replace('/login');
      } else if (error.response && ["Not subscribed", "Not stripe customer"].includes(error.response.data.message)) {
        // pass
      } else {
        this.$Message.error({content: error.message, duration: 5});
      }
    });

    axios.get(process.env.VUE_APP_ROOT_API + '/api/feide/groups').then(response => {
      this.feideInfo.loading = false;
      this.feideInfo.data = response.data;
      this.feideInfo.available = true;
    }).catch(error => {
      this.feideInfo.loading = false;
      if (error.response && error.response.status === 401) {
        this.$store.dispatch('license/logOut');
        this.$router.replace('/login');
      } else if (error.response && error.response.data.message == "no feide") {
        // pass
      } else {
        this.$Message.error({content: error.message, duration: 5});
      }
    });

    // if (!cardElement) {
    //   cardElement = elements.create('card', {
    //     hidePostalCode: true,
    //     iconStyle: "solid",
    //     classes: {base: 'StripeElement ivu-input ivu-input-default'},
    //     style: {
    //       base: {
    //         iconColor: "#999",
    //         color: "#333",
    //         fontWeight: 400,
    //         fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
    //         fontSize: "12px",
    //         fontSmoothing: "antialiased",

    //         "::placeholder": {
    //           color: "#c5c8ce"
    //         },
    //         ":-webkit-autofill": {
    //           color: "#c5c8ce"
    //         }
    //       },
    //       invalid: {
    //         iconColor: "#ed4014",
    //         color: "#ed4014"
    //       }
    //     }
    //   });
    // }
    // cardElement.mount(this.$refs.card);
  },
  data() {
    return {
      licenseInfo: {
        loading: true,
        license: {},
        appCollections: [],
      },
      stripeInfo: {
        loading: true,
        available: false,
        data: {}
      },
      feideInfo: {
        loading: true,
        available: false,
        data: []
      },
      addCard: {
        show: false,
        loading: true,
        error: null
      }
    }
  },
  computed: {
    ...mapState({
      license: state => state.license.license,
      resourceAccess: state => state.license.license && ((state.license.license.type & 4) > 0)
    }),
    billingPortalUrl() {
      return process.env.VUE_APP_ROOT_API + '/api/stripe/open_billing_portal?return_url=' + location.href;
    },
  },
  watch: {
    resourceAccess(access) {
      if (access) {
        this.$router.replace('/manage/videos');
      }
    }
  },
  methods: {
    stripeValidate() {
      stripe.createPaymentMethod({
        type: 'card',
        card: null,//cardElement,
      }).then(result => {
        if (result.error) {
          this.addCard.loading = false;
          setTimeout(() => {this.addCard.loading = true;}, 100);
          this.addCard.error = result.error.message;
          return;
        }

        this.$nextTick(() => {
          this.postAddCard(result.token);
        });
      });
    },
    postAddCard(token) {
      axios.post(process.env.VUE_APP_ROOT_API + '/api/stripe/card/add', { token: token }).then(response => {
        this.stripeInfo.data.cards.push(response.data);
        this.addCard.show = false;
        //cardElement.clear();
      }).catch(error => {
        this.addCard.loading = false;
        setTimeout(() => {this.addCard.loading = true;}, 100);
        if (error.response) {
          this.addCard.error = error.response.data.message;
        } else {
          this.addCard.error = error.message;
        }
      });
    },
    getFeideChildren(groups) {
      var res = [];
      groups.reduce((r, val) => {
        if (val.children) {
          res.push.apply(res, this.getFeideChildren(val.children));
        } else {
          res.push(val);
        }
        return r
      }, res);
      return res;
    },
    feideCheck(selected, current) {
      this.feideInfo.loading = true;
      let groups = this.getFeideChildren([current]);
      axios.post(process.env.VUE_APP_ROOT_API + '/api/feide/groups/access', { groups: groups }).then(() => {
        this.feideInfo.loading = false;

      }).catch(error => {
        this.feideInfo.loading = false;
        if (error.response) {
          // this.addCard.error = error.response.data.message;
        } else {
          // this.addCard.error = error.message;
        }
      });
    }
  },
  components: {
    ElementLoader,
    // SavedCard,
    // Invoice,
    // Subscription
  }
}
</script>

<style scoped lang="scss">
.main-content {
  text-align: center;

  .billing-portal-btn {
    background: none;
    border: none;
    color: #0066ff;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .ivu-card {
    margin: 40px auto;

    .group {
      margin-bottom: 0;
    }
  }

  .add-card {
    height: 35px;
    width: 135px;
    margin: 0 auto;
    border: 1px dashed #999;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      border-color: #2d8cf0;

      span {
        color: #2d8cf0;
      }
    }

    span {
      color: rgba(0, 0, 0, 0.25);
      font-size: 28px;
      margin-top: -8px;
    }
  }

  .ivu-collapse {
    margin: 40px auto;
  }

  ul {
    list-style: none;

    li {
      line-height: 24px !important;
    }
  }
}
</style>